export const useLivekitUnblockAudio = () => ({
  isAudioBlocked: false,
  unblockAudio: () => null,
});
